var map = {
	"./Goblet.png": 24375,
	"./Icon_Accessories_Common.png": 10438,
	"./Item_Icon_Accessories_Epic.png": 16964,
	"./Item_Icon_Accessories_Legendary.png": 79764,
	"./Item_Icon_Accessories_Poor.png": 31599,
	"./Item_Icon_Accessories_Rare.png": 7995,
	"./Item_Icon_Accessories_Uncommon.png": 54197,
	"./Item_Icon_Accessories_Unique.png": 96078,
	"./Item_Icon_AdditionalStashTab.png": 4421,
	"./Item_Icon_AdventurerBoots copy.png": 29410,
	"./Item_Icon_AdventurerBoots.png": 71965,
	"./Item_Icon_AdventurerCloak copy.png": 96795,
	"./Item_Icon_AdventurerCloak.png": 77362,
	"./Item_Icon_AdventurerTunic_0001 copy.png": 22950,
	"./Item_Icon_AdventurerTunic_0001.png": 10849,
	"./Item_Icon_AdventurerTunic_1001.png": 19778,
	"./Item_Icon_AdventurerTunic_2001 copy.png": 99940,
	"./Item_Icon_AdventurerTunic_2001.png": 9451,
	"./Item_Icon_AdventurerTunic_3001.png": 42732,
	"./Item_Icon_AdventurerTunic_4001 copy.png": 17698,
	"./Item_Icon_AdventurerTunic_4001.png": 21565,
	"./Item_Icon_AdventurerTunic_5001 copy.png": 72103,
	"./Item_Icon_AdventurerTunic_5001.png": 27454,
	"./Item_Icon_AdventurerTunic_6001 copy.png": 72928,
	"./Item_Icon_AdventurerTunic_6001.png": 17191,
	"./Item_Icon_AdventurerTunic_7001.png": 16056,
	"./Item_Icon_Ail copy.png": 12471,
	"./Item_Icon_Ale.png": 59540,
	"./Item_Icon_Armet copy.png": 91110,
	"./Item_Icon_Armet.png": 56001,
	"./Item_Icon_ArmingSword_0001 copy.png": 25464,
	"./Item_Icon_ArmingSword_1001.png": 27680,
	"./Item_Icon_ArmingSword_2001 copy.png": 77626,
	"./Item_Icon_ArmingSword_3001 copy.png": 80223,
	"./Item_Icon_ArmingSword_3001.png": 12518,
	"./Item_Icon_ArmingSword_4001 copy.png": 72668,
	"./Item_Icon_ArmingSword_5001 copy.png": 72873,
	"./Item_Icon_ArmingSword_6001 copy.png": 96734,
	"./Item_Icon_ArmingSword_7001 copy.png": 77475,
	"./Item_Icon_Armingsword_0001.png": 70287,
	"./Item_Icon_Armingsword_2001.png": 60549,
	"./Item_Icon_Armingsword_4001.png": 47859,
	"./Item_Icon_Armingsword_5001.png": 980,
	"./Item_Icon_Armingsword_6001.png": 53065,
	"./Item_Icon_Armingsword_7001.png": 32266,
	"./Item_Icon_ArmorScrap.png": 73546,
	"./Item_Icon_Armors_Common.png": 39432,
	"./Item_Icon_Armors_Epic.png": 73484,
	"./Item_Icon_Armors_Legend.png": 32008,
	"./Item_Icon_Armors_Legendary.png": 32780,
	"./Item_Icon_Armors_Poor.png": 58503,
	"./Item_Icon_Armors_Rare.png": 5235,
	"./Item_Icon_Armors_Uncommon.png": 85837,
	"./Item_Icon_Armors_Unique.png": 11366,
	"./Item_Icon_Arrow copy.png": 90472,
	"./Item_Icon_Arrow.png": 28095,
	"./Item_Icon_AxeofRighteousness copy.png": 58149,
	"./Item_Icon_AxeofRighteousness.png": 56416,
	"./Item_Icon_BadgerPendant copy.png": 68682,
	"./Item_Icon_BadgerPendant.png": 58453,
	"./Item_Icon_Bandage copy.png": 24507,
	"./Item_Icon_Bandage.png": 72306,
	"./Item_Icon_BansheeSonnet.png": 37349,
	"./Item_Icon_BarbutaHelm copy.png": 6550,
	"./Item_Icon_BarbutaHelm.png": 98961,
	"./Item_Icon_BardicPants copy.png": 54754,
	"./Item_Icon_BardicPants.png": 99453,
	"./Item_Icon_Bardiche copy.png": 29291,
	"./Item_Icon_Bardiche.png": 7298,
	"./Item_Icon_Bardiche_0001 copy.png": 32095,
	"./Item_Icon_Bardiche_0001.png": 40230,
	"./Item_Icon_Bardiche_1001.png": 10725,
	"./Item_Icon_Bardiche_2001 copy.png": 80325,
	"./Item_Icon_Bardiche_2001.png": 71744,
	"./Item_Icon_Bardiche_3001 copy.png": 21208,
	"./Item_Icon_Bardiche_3001.png": 90543,
	"./Item_Icon_Bardiche_4001 copy.png": 18275,
	"./Item_Icon_Bardiche_4001.png": 44778,
	"./Item_Icon_Bardiche_5001 copy.png": 98910,
	"./Item_Icon_Bardiche_5001.png": 81705,
	"./Item_Icon_Bardiche_6001 copy.png": 48425,
	"./Item_Icon_Bardiche_6001.png": 93716,
	"./Item_Icon_Bardiche_7001 copy.png": 72764,
	"./Item_Icon_Bardiche_7001.png": 16083,
	"./Item_Icon_BasicNecklace02.png": 77392,
	"./Item_Icon_BasicNecklace03.png": 74297,
	"./Item_Icon_BasicNecklace04.png": 81222,
	"./Item_Icon_BasicNecklace05.png": 20239,
	"./Item_Icon_BasicRing01.png": 99193,
	"./Item_Icon_BasicRing02.png": 51010,
	"./Item_Icon_BasicRing03.png": 72139,
	"./Item_Icon_BasicRing04.png": 26228,
	"./Item_Icon_BatClaw.png": 57440,
	"./Item_Icon_BatWing.png": 16440,
	"./Item_Icon_BattleAxe_0001 copy.png": 16303,
	"./Item_Icon_BattleAxe_0001.png": 6998,
	"./Item_Icon_BattleAxe_1001.png": 41717,
	"./Item_Icon_BattleAxe_2001 copy.png": 42037,
	"./Item_Icon_BattleAxe_2001.png": 43792,
	"./Item_Icon_BattleAxe_3001 copy.png": 48904,
	"./Item_Icon_BattleAxe_3001.png": 58815,
	"./Item_Icon_BattleAxe_4001 copy.png": 36243,
	"./Item_Icon_BattleAxe_4001.png": 93434,
	"./Item_Icon_BattleAxe_5001 copy.png": 96526,
	"./Item_Icon_BattleAxe_5001.png": 34713,
	"./Item_Icon_BattleAxe_6001 copy.png": 54201,
	"./Item_Icon_BattleAxe_6001.png": 53540,
	"./Item_Icon_BattleAxe_7001 copy.png": 93420,
	"./Item_Icon_BattleAxe_7001.png": 22371,
	"./Item_Icon_BearPendant copy.png": 94401,
	"./Item_Icon_BearPendant.png": 71612,
	"./Item_Icon_BeetleWings copy.png": 80,
	"./Item_Icon_BeetleWings.png": 95575,
	"./Item_Icon_BladeofRighteousness copy.png": 79843,
	"./Item_Icon_BladeofRighteousness.png": 70762,
	"./Item_Icon_BlueEyeballs copy.png": 26062,
	"./Item_Icon_BlueEyeballs.png": 79929,
	"./Item_Icon_BlueSapphire copy.png": 87645,
	"./Item_Icon_BlueSapphire.png": 51496,
	"./Item_Icon_Bolt copy.png": 48292,
	"./Item_Icon_Bolt.png": 14059,
	"./Item_Icon_Bone copy.png": 32505,
	"./Item_Icon_Bone.png": 32708,
	"./Item_Icon_BoneShaper copy.png": 36048,
	"./Item_Icon_BoneShaper.png": 42167,
	"./Item_Icon_BowofRighteousness copy.png": 30225,
	"./Item_Icon_BowofRighteousness.png": 39052,
	"./Item_Icon_Bowstring copy.png": 42372,
	"./Item_Icon_Bowstring.png": 16683,
	"./Item_Icon_BraveHunterPants copy.png": 89313,
	"./Item_Icon_BraveHunterPants.png": 32732,
	"./Item_Icon_BrokenSkull copy.png": 29867,
	"./Item_Icon_BrokenSkull.png": 64930,
	"./Item_Icon_BuckledBoots copy.png": 49342,
	"./Item_Icon_BuckledBoots.png": 40681,
	"./Item_Icon_Buckler_0001 copy.png": 69123,
	"./Item_Icon_Buckler_0001.png": 74186,
	"./Item_Icon_Buckler_1001 copy.png": 88382,
	"./Item_Icon_Buckler_1001.png": 7561,
	"./Item_Icon_Buckler_2001 copy.png": 64521,
	"./Item_Icon_Buckler_2001.png": 19572,
	"./Item_Icon_Buckler_3001.png": 18643,
	"./Item_Icon_Buckler_4001 copy.png": 71871,
	"./Item_Icon_Buckler_4001.png": 23558,
	"./Item_Icon_Buckler_5001 copy.png": 85626,
	"./Item_Icon_Buckler_5001.png": 40133,
	"./Item_Icon_Buckler_6001 copy.png": 24997,
	"./Item_Icon_Buckler_6001.png": 55072,
	"./Item_Icon_Buckler_7001 copy.png": 33464,
	"./Item_Icon_Buckler_7001.png": 93103,
	"./Item_Icon_BugShell copy.png": 36503,
	"./Item_Icon_BugShell.png": 68270,
	"./Item_Icon_CampfireKit copy.png": 32378,
	"./Item_Icon_CampfireKit.png": 85861,
	"./Item_Icon_CandyCane copy.png": 58301,
	"./Item_Icon_CandyCane.png": 71080,
	"./Item_Icon_CandyCorn copy.png": 80030,
	"./Item_Icon_CandyCorn.png": 32905,
	"./Item_Icon_CapturedManaFlakes copy.png": 30476,
	"./Item_Icon_CapturedManaFlakes.png": 42627,
	"./Item_Icon_CastillonDagger_0001 copy.png": 38146,
	"./Item_Icon_CastillonDagger_0001.png": 54813,
	"./Item_Icon_CastillonDagger_1001 copy.png": 97351,
	"./Item_Icon_CastillonDagger_1001.png": 57150,
	"./Item_Icon_CastillonDagger_2001 copy.png": 39392,
	"./Item_Icon_CastillonDagger_2001.png": 32615,
	"./Item_Icon_CastillonDagger_3001.png": 22456,
	"./Item_Icon_CastillonDagger_4001 copy.png": 84198,
	"./Item_Icon_CastillonDagger_4001.png": 86625,
	"./Item_Icon_CastillonDagger_5001 copy.png": 21419,
	"./Item_Icon_CastillonDagger_5001.png": 69378,
	"./Item_Icon_CastillonDagger_6001 copy.png": 24964,
	"./Item_Icon_CastillonDagger_6001.png": 12971,
	"./Item_Icon_CastillonDagger_7001 copy.png": 85457,
	"./Item_Icon_CastillonDagger_7001.png": 15628,
	"./Item_Icon_CaveTrollsPreciousRock.png": 51760,
	"./Item_Icon_CentaurHoof copy.png": 71079,
	"./Item_Icon_CentaurHoof.png": 1694,
	"./Item_Icon_CentaurHorn copy.png": 92750,
	"./Item_Icon_CentaurHorn.png": 90585,
	"./Item_Icon_CentaurTail copy.png": 9689,
	"./Item_Icon_CentaurTail.png": 43684,
	"./Item_Icon_CentaursMadness copy.png": 6569,
	"./Item_Icon_CentaursMadness.png": 5620,
	"./Item_Icon_CeremonialDagger copy.png": 17644,
	"./Item_Icon_CeremonialDagger.png": 52355,
	"./Item_Icon_CeremonialStaff copy.png": 25544,
	"./Item_Icon_CeremonialStaff.png": 78175,
	"./Item_Icon_ChampionArmor copy.png": 96787,
	"./Item_Icon_ChampionArmor.png": 27194,
	"./Item_Icon_ChapelDeFer copy.png": 58684,
	"./Item_Icon_ChapelDeFer.png": 25587,
	"./Item_Icon_Chaperon copy.png": 29111,
	"./Item_Icon_Chaperon.png": 20270,
	"./Item_Icon_ChocolateChipMuffin.png": 77807,
	"./Item_Icon_ChroniclesoftheCursedCrown.png": 26707,
	"./Item_Icon_ClarityPotion copy.png": 57682,
	"./Item_Icon_ClarityPotion.png": 99533,
	"./Item_Icon_ClarityPotion_BoneDecoratedBottle.png": 3497,
	"./Item_Icon_CloakofDarkness copy.png": 67911,
	"./Item_Icon_CloakofDarkness.png": 32030,
	"./Item_Icon_ClothPants_0001 copy.png": 15077,
	"./Item_Icon_ClothPants_0001.png": 64832,
	"./Item_Icon_ClothPants_1001 copy.png": 38616,
	"./Item_Icon_ClothPants_1001.png": 62639,
	"./Item_Icon_ClothPants_2001 copy.png": 66655,
	"./Item_Icon_ClothPants_2001.png": 29606,
	"./Item_Icon_ClothPants_3001.png": 98981,
	"./Item_Icon_ClothPants_4001 copy.png": 38537,
	"./Item_Icon_ClothPants_4001.png": 23060,
	"./Item_Icon_ClothPants_5001 copy.png": 75612,
	"./Item_Icon_ClothPants_5001.png": 74387,
	"./Item_Icon_ClothPants_6001 copy.png": 40131,
	"./Item_Icon_ClothPants_6001.png": 82090,
	"./Item_Icon_ClothPants_7001.png": 22121,
	"./Item_Icon_Club copy.png": 93639,
	"./Item_Icon_Club.png": 28830,
	"./Item_Icon_CobaltChapelDeFer copy.png": 11937,
	"./Item_Icon_CobaltChapelDeFer.png": 73276,
	"./Item_Icon_CobaltFrock copy.png": 55107,
	"./Item_Icon_CobaltFrock.png": 41578,
	"./Item_Icon_CobaltHat copy.png": 8633,
	"./Item_Icon_CobaltHat.png": 25604,
	"./Item_Icon_CobaltHeavyGauntlet copy.png": 33785,
	"./Item_Icon_CobaltHeavyGauntlet.png": 1220,
	"./Item_Icon_CobaltHood copy.png": 45598,
	"./Item_Icon_CobaltHood.png": 30217,
	"./Item_Icon_CobaltIngot copy.png": 73107,
	"./Item_Icon_CobaltIngot.png": 13498,
	"./Item_Icon_CobaltIngots copy.png": 10004,
	"./Item_Icon_CobaltIngots.png": 13755,
	"./Item_Icon_CobaltLeatherGloves copy.png": 82807,
	"./Item_Icon_CobaltLeatherGloves.png": 83534,
	"./Item_Icon_CobaltLightfootBoots copy.png": 62757,
	"./Item_Icon_CobaltLightfootBoots.png": 11104,
	"./Item_Icon_CobaltOre copy.png": 63908,
	"./Item_Icon_CobaltOre.png": 41291,
	"./Item_Icon_CobaltOres copy.png": 99389,
	"./Item_Icon_CobaltOres.png": 9864,
	"./Item_Icon_CobaltPlateBoots copy.png": 68073,
	"./Item_Icon_CobaltPlateBoots.png": 57012,
	"./Item_Icon_CobaltPlatePants copy.png": 88034,
	"./Item_Icon_CobaltPlatePants.png": 99709,
	"./Item_Icon_CobaltPowder copy.png": 92101,
	"./Item_Icon_CobaltPowder.png": 21792,
	"./Item_Icon_CobaltRegalGambeson copy.png": 6937,
	"./Item_Icon_CobaltRegalGambeson.png": 53252,
	"./Item_Icon_CobaltTemplarArmor copy.png": 75904,
	"./Item_Icon_CobaltTemplarArmor.png": 43111,
	"./Item_Icon_CobaltTrousers copy.png": 88313,
	"./Item_Icon_CobaltTrousers.png": 58852,
	"./Item_Icon_CobaltVikingHelm copy.png": 41766,
	"./Item_Icon_CobaltVikingHelm.png": 34209,
	"./Item_Icon_CockatriceEgg.png": 56767,
	"./Item_Icon_CockatricesLuckyFeather.png": 17306,
	"./Item_Icon_CoinBag copy.png": 63792,
	"./Item_Icon_CoinBag.png": 19767,
	"./Item_Icon_CoinChest_00.png": 50975,
	"./Item_Icon_CoinPurse copy.png": 88701,
	"./Item_Icon_CoinPurse.png": 51880,
	"./Item_Icon_CopperIngot copy.png": 85913,
	"./Item_Icon_CopperIngot.png": 82980,
	"./Item_Icon_CopperIngots copy.png": 93866,
	"./Item_Icon_CopperIngots.png": 1941,
	"./Item_Icon_CopperOre copy.png": 81230,
	"./Item_Icon_CopperOre.png": 29318,
	"./Item_Icon_CopperOres copy.png": 70207,
	"./Item_Icon_CopperOres.png": 32358,
	"./Item_Icon_CopperPowder copy.png": 21071,
	"./Item_Icon_CopperPowder.png": 27606,
	"./Item_Icon_CopperlightAttire copy.png": 40649,
	"./Item_Icon_CopperlightAttire.png": 81748,
	"./Item_Icon_CopperlightGauntlet.png": 32695,
	"./Item_Icon_CopperlightGauntlets copy.png": 24353,
	"./Item_Icon_CopperlightGauntlets.png": 51612,
	"./Item_Icon_CopperlightKettleHat copy.png": 58734,
	"./Item_Icon_CopperlightKettleHat.png": 93689,
	"./Item_Icon_CopperlightLeggings copy.png": 16470,
	"./Item_Icon_CopperlightLeggings.png": 45969,
	"./Item_Icon_CopperlightLightfootBoots copy.png": 61167,
	"./Item_Icon_CopperlightLightfootBoots.png": 45462,
	"./Item_Icon_CopperlightOutfit copy.png": 44973,
	"./Item_Icon_CopperlightOutfit.png": 54872,
	"./Item_Icon_CopperlightPants copy.png": 42092,
	"./Item_Icon_CopperlightPants.png": 89475,
	"./Item_Icon_CopperlightPlateBoots copy.png": 32691,
	"./Item_Icon_CopperlightPlateBoots.png": 62874,
	"./Item_Icon_CopperlightPlatePants copy.png": 16628,
	"./Item_Icon_CopperlightPlatePants.png": 77915,
	"./Item_Icon_CopperlightRivetedGloves copy.png": 75161,
	"./Item_Icon_CopperlightRivetedGloves.png": 68452,
	"./Item_Icon_CopperlightSanctumPlateArmor copy.png": 10682,
	"./Item_Icon_CopperlightSanctumPlateArmor.png": 35781,
	"./Item_Icon_CopperlightStrawHat copy.png": 38298,
	"./Item_Icon_CopperlightStrawHat.png": 47333,
	"./Item_Icon_CopperlightTunic copy.png": 16817,
	"./Item_Icon_CopperlightTunic.png": 79884,
	"./Item_Icon_CowlofDarkness copy.png": 98464,
	"./Item_Icon_CowlofDarkness.png": 24135,
	"./Item_Icon_Crossbow_0001 copy.png": 2679,
	"./Item_Icon_Crossbow_0001.png": 73102,
	"./Item_Icon_Crossbow_1001 copy.png": 64498,
	"./Item_Icon_Crossbow_1001.png": 91277,
	"./Item_Icon_Crossbow_2001 copy.png": 20061,
	"./Item_Icon_Crossbow_2001.png": 65800,
	"./Item_Icon_Crossbow_3001.png": 21303,
	"./Item_Icon_Crossbow_4001 copy.png": 4283,
	"./Item_Icon_Crossbow_4001.png": 63154,
	"./Item_Icon_Crossbow_5001 copy.png": 20726,
	"./Item_Icon_Crossbow_5001.png": 59345,
	"./Item_Icon_Crossbow_6001 copy.png": 86945,
	"./Item_Icon_Crossbow_6001.png": 65212,
	"./Item_Icon_Crossbow_7001.png": 22459,
	"./Item_Icon_CrusaderArmor copy.png": 12467,
	"./Item_Icon_CrusaderArmor.png": 40218,
	"./Item_Icon_CrusaderHelm copy.png": 20844,
	"./Item_Icon_CrusaderHelm.png": 5187,
	"./Item_Icon_CrystalBall_0001 copy.png": 95996,
	"./Item_Icon_CrystalBall_0001.png": 78291,
	"./Item_Icon_CrystalBall_1001 copy.png": 96201,
	"./Item_Icon_CrystalBall_1001.png": 79220,
	"./Item_Icon_CrystalBall_2001 copy.png": 20062,
	"./Item_Icon_CrystalBall_2001.png": 50857,
	"./Item_Icon_CrystalBall_3001.png": 17482,
	"./Item_Icon_CrystalBall_4001 copy.png": 48792,
	"./Item_Icon_CrystalBall_4001.png": 52751,
	"./Item_Icon_CrystalBall_5001 copy.png": 56677,
	"./Item_Icon_CrystalBall_5001.png": 98368,
	"./Item_Icon_CrystalBall_6001 copy.png": 954,
	"./Item_Icon_CrystalBall_6001.png": 83429,
	"./Item_Icon_CrystalBall_7001 copy.png": 3551,
	"./Item_Icon_CrystalBall_7001.png": 83206,
	"./Item_Icon_CrystalSword_0001 copy.png": 80578,
	"./Item_Icon_CrystalSword_0001.png": 1917,
	"./Item_Icon_CrystalSword_1001 copy.png": 56135,
	"./Item_Icon_CrystalSword_1001.png": 4254,
	"./Item_Icon_CrystalSword_2001 copy.png": 98176,
	"./Item_Icon_CrystalSword_2001.png": 63367,
	"./Item_Icon_CrystalSword_3001.png": 69560,
	"./Item_Icon_CrystalSword_4001 copy.png": 26630,
	"./Item_Icon_CrystalSword_4001.png": 33729,
	"./Item_Icon_CrystalSword_5001 copy.png": 63851,
	"./Item_Icon_CrystalSword_5001.png": 130,
	"./Item_Icon_CrystalSword_6001 copy.png": 67396,
	"./Item_Icon_CrystalSword_6001.png": 60075,
	"./Item_Icon_CrystalSword_7001 copy.png": 44241,
	"./Item_Icon_CrystalSword_7001.png": 46380,
	"./Item_Icon_CursedCrown.png": 60735,
	"./Item_Icon_CyclopsClub copy.png": 80668,
	"./Item_Icon_CyclopsClub.png": 66131,
	"./Item_Icon_CyclopsEye copy.png": 7205,
	"./Item_Icon_CyclopsEye.png": 34400,
	"./Item_Icon_CyclopsPreciousMirror.png": 71620,
	"./Item_Icon_CyclopsRags copy.png": 53739,
	"./Item_Icon_CyclopsRags.png": 66946,
	"./Item_Icon_CyclopsVisionCrystal copy.png": 77974,
	"./Item_Icon_CyclopsVisionCrystal.png": 97841,
	"./Item_Icon_DaggerofRighteousness copy.png": 10477,
	"./Item_Icon_DaggerofRighteousness.png": 34712,
	"./Item_Icon_DarkCuirass copy.png": 61921,
	"./Item_Icon_DarkCuirass.png": 84508,
	"./Item_Icon_DarkLeatherLeggings_0001 copy.png": 48662,
	"./Item_Icon_DarkLeatherLeggings_0001.png": 57361,
	"./Item_Icon_DarkLeatherLeggings_1001 copy.png": 58779,
	"./Item_Icon_DarkLeatherLeggings_1001.png": 31730,
	"./Item_Icon_DarkLeatherLeggings_2001 copy.png": 77428,
	"./Item_Icon_DarkLeatherLeggings_2001.png": 81051,
	"./Item_Icon_DarkLeatherLeggings_3001.png": 75164,
	"./Item_Icon_DarkLeatherLeggings_4001 copy.png": 38386,
	"./Item_Icon_DarkLeatherLeggings_4001.png": 22317,
	"./Item_Icon_DarkLeatherLeggings_5001 copy.png": 983,
	"./Item_Icon_DarkLeatherLeggings_5001.png": 75854,
	"./Item_Icon_DarkLeatherLeggings_6001 copy.png": 10096,
	"./Item_Icon_DarkLeatherLeggings_6001.png": 43511,
	"./Item_Icon_DarkLeatherLeggings_7001.png": 85832,
	"./Item_Icon_DarkMatter copy.png": 29566,
	"./Item_Icon_DarkMatter.png": 2985,
	"./Item_Icon_DarkMatterTunic.png": 84844,
	"./Item_Icon_DarkPlateArmor copy.png": 31276,
	"./Item_Icon_DarkPlateArmor.png": 96739,
	"./Item_Icon_DarkgroveHood copy.png": 62488,
	"./Item_Icon_DarkgroveHood.png": 19823,
	"./Item_Icon_DarkgroveRobe.png": 72967,
	"./Item_Icon_DarkleafBoots copy.png": 92360,
	"./Item_Icon_DarkleafBoots.png": 36863,
	"./Item_Icon_DashingBoots copy.png": 72522,
	"./Item_Icon_DashingBoots.png": 76117,
	"./Item_Icon_DemonBlood copy.png": 87230,
	"./Item_Icon_DemonBlood.png": 59049,
	"./Item_Icon_DemonDogThorns.png": 27209,
	"./Item_Icon_DemonGripGloves copy.png": 84796,
	"./Item_Icon_DemonGripGloves.png": 13459,
	"./Item_Icon_DemoncladLeggings copy.png": 91204,
	"./Item_Icon_DemoncladLeggings.png": 25195,
	"./Item_Icon_DemonsGlee copy.png": 69586,
	"./Item_Icon_DemonsGlee.png": 80749,
	"./Item_Icon_Diamond copy.png": 73193,
	"./Item_Icon_Diamond.png": 93620,
	"./Item_Icon_DiaryoftheToz.png": 80150,
	"./Item_Icon_DivineAxe copy.png": 1008,
	"./Item_Icon_DivineAxe.png": 16503,
	"./Item_Icon_DivineBlade copy.png": 89826,
	"./Item_Icon_DivineBlade.png": 25277,
	"./Item_Icon_DivineBow copy.png": 86112,
	"./Item_Icon_DivineBow.png": 93460,
	"./Item_Icon_DivineDagger copy.png": 95278,
	"./Item_Icon_DivineDagger.png": 9465,
	"./Item_Icon_DivineRod copy.png": 32785,
	"./Item_Icon_DivineRod.png": 60364,
	"./Item_Icon_DivineShortSword copy.png": 64463,
	"./Item_Icon_DivineShortSword.png": 83254,
	"./Item_Icon_DivineStaff copy.png": 85574,
	"./Item_Icon_DivineStaff.png": 38625,
	"./Item_Icon_DogCollar.png": 41353,
	"./Item_Icon_DoubleAxe_0001 copy.png": 16912,
	"./Item_Icon_DoubleAxe_0001.png": 91063,
	"./Item_Icon_DoubleAxe_1001 copy.png": 64573,
	"./Item_Icon_DoubleAxe_1001.png": 1384,
	"./Item_Icon_DoubleAxe_2001 copy.png": 64434,
	"./Item_Icon_DoubleAxe_2001.png": 3565,
	"./Item_Icon_DoubleAxe_3001.png": 66158,
	"./Item_Icon_DoubleAxe_4001 copy.png": 96852,
	"./Item_Icon_DoubleAxe_4001.png": 92219,
	"./Item_Icon_DoubleAxe_5001 copy.png": 71009,
	"./Item_Icon_DoubleAxe_5001.png": 84444,
	"./Item_Icon_DoubleAxe_6001 copy.png": 68566,
	"./Item_Icon_DoubleAxe_6001.png": 29105,
	"./Item_Icon_DoubleAxe_7001 copy.png": 38395,
	"./Item_Icon_DoubleAxe_7001.png": 63538,
	"./Item_Icon_Doublet copy.png": 67154,
	"./Item_Icon_Doublet.png": 21037,
	"./Item_Icon_DreadHood copy.png": 91767,
	"./Item_Icon_DreadHood.png": 48270,
	"./Item_Icon_Drum_0001 copy.png": 44095,
	"./Item_Icon_Drum_0001.png": 77318,
	"./Item_Icon_Drum_1001 copy.png": 58170,
	"./Item_Icon_Drum_1001.png": 31461,
	"./Item_Icon_Drum_2001 copy.png": 92325,
	"./Item_Icon_Drum_2001.png": 92480,
	"./Item_Icon_Drum_3001.png": 27631,
	"./Item_Icon_Drum_4001 copy.png": 30275,
	"./Item_Icon_Drum_4001.png": 81866,
	"./Item_Icon_Drum_5001 copy.png": 10910,
	"./Item_Icon_Drum_5001.png": 2441,
	"./Item_Icon_Drum_6001 copy.png": 60425,
	"./Item_Icon_Drum_6001.png": 30804,
	"./Item_Icon_Drum_7001.png": 53171,
	"./Item_Icon_Ectoplasm.png": 33516,
	"./Item_Icon_ElkwoodCrown copy.png": 77309,
	"./Item_Icon_ElkwoodCrown.png": 35848,
	"./Item_Icon_ElkwoodGloves copy.png": 88360,
	"./Item_Icon_ElkwoodGloves.png": 57567,
	"./Item_Icon_Emerald copy.png": 48045,
	"./Item_Icon_Emerald.png": 79640,
	"./Item_Icon_EnchantedDarkFabric copy.png": 7320,
	"./Item_Icon_EnchantedDarkFabric.png": 90383,
	"./Item_Icon_Experience.png": 33470,
	"./Item_Icon_ExplosionBottle copy.png": 85966,
	"./Item_Icon_ExplosionBottle.png": 97273,
	"./Item_Icon_ExplosiveBottle.png": 36297,
	"./Item_Icon_ExtraThickPelts.png": 63727,
	"./Item_Icon_Falchion_0001 copy.png": 2213,
	"./Item_Icon_Falchion_0001.png": 62464,
	"./Item_Icon_Falchion_1001 copy.png": 43096,
	"./Item_Icon_Falchion_1001.png": 81263,
	"./Item_Icon_Falchion_2001 copy.png": 53983,
	"./Item_Icon_Falchion_2001.png": 47302,
	"./Item_Icon_Falchion_3001.png": 1445,
	"./Item_Icon_Falchion_4001 copy.png": 53961,
	"./Item_Icon_Falchion_4001.png": 84436,
	"./Item_Icon_Falchion_5001 copy.png": 78300,
	"./Item_Icon_Falchion_5001.png": 6803,
	"./Item_Icon_Falchion_6001 copy.png": 23811,
	"./Item_Icon_Falchion_6001.png": 35498,
	"./Item_Icon_Falchion_7001 copy.png": 20798,
	"./Item_Icon_Falchion_7001.png": 72425,
	"./Item_Icon_FalchionofHonor copy.png": 80508,
	"./Item_Icon_FalchionofHonor.png": 98323,
	"./Item_Icon_FangsofDeathNecklace copy.png": 98667,
	"./Item_Icon_FangsofDeathNecklace.png": 75490,
	"./Item_Icon_FeatheredHat copy.png": 65596,
	"./Item_Icon_FeatheredHat.png": 79603,
	"./Item_Icon_FellingAxe_0001 copy.png": 84212,
	"./Item_Icon_FellingAxe_0001.png": 2427,
	"./Item_Icon_FellingAxe_1001 copy.png": 63425,
	"./Item_Icon_FellingAxe_1001.png": 96540,
	"./Item_Icon_FellingAxe_2001 copy.png": 55446,
	"./Item_Icon_FellingAxe_2001.png": 78737,
	"./Item_Icon_FellingAxe_3001.png": 53106,
	"./Item_Icon_FellingAxe_4001 copy.png": 16880,
	"./Item_Icon_FellingAxe_4001.png": 64887,
	"./Item_Icon_FellingAxe_5001 copy.png": 79101,
	"./Item_Icon_FellingAxe_5001.png": 7208,
	"./Item_Icon_FellingAxe_6001 copy.png": 45170,
	"./Item_Icon_FellingAxe_6001.png": 43693,
	"./Item_Icon_FellingAxe_7001 copy.png": 91415,
	"./Item_Icon_FellingAxe_7001.png": 97230,
	"./Item_Icon_FineCuirass copy.png": 48481,
	"./Item_Icon_FineCuirass.png": 82716,
	"./Item_Icon_FireflysAbdomen copy.png": 80541,
	"./Item_Icon_FireflysAbdomen.png": 53736,
	"./Item_Icon_FlangedMace_0001 copy.png": 44794,
	"./Item_Icon_FlangedMace_0001.png": 11557,
	"./Item_Icon_FlangedMace_1001.png": 37734,
	"./Item_Icon_FlangedMace_2001 copy.png": 92504,
	"./Item_Icon_FlangedMace_2001.png": 4943,
	"./Item_Icon_FlangedMace_3001.png": 46784,
	"./Item_Icon_FlangedMace_4001 copy.png": 94174,
	"./Item_Icon_FlangedMace_4001.png": 4073,
	"./Item_Icon_FlangedMace_5001 copy.png": 58243,
	"./Item_Icon_FlangedMace_5001.png": 66922,
	"./Item_Icon_FlangedMace_6001 copy.png": 95772,
	"./Item_Icon_FlangedMace_6001.png": 82515,
	"./Item_Icon_FlangedMace_7001 copy.png": 97225,
	"./Item_Icon_FlangedMace_7001.png": 35636,
	"./Item_Icon_Flute copy.png": 57091,
	"./Item_Icon_Flute.png": 85962,
	"./Item_Icon_ForestBoots copy.png": 96495,
	"./Item_Icon_ForestBoots.png": 66422,
	"./Item_Icon_ForestHood copy.png": 87540,
	"./Item_Icon_ForestHood.png": 795,
	"./Item_Icon_FoulBoots copy.png": 79706,
	"./Item_Icon_FoulBoots.png": 79269,
	"./Item_Icon_FoxPendant copy.png": 94370,
	"./Item_Icon_FoxPendant.png": 99229,
	"./Item_Icon_FranciscaAxe copy.png": 38531,
	"./Item_Icon_FranciscaAxe.png": 50858,
	"./Item_Icon_Frock copy.png": 60498,
	"./Item_Icon_Frock.png": 71309,
	"./Item_Icon_FrostAmulet.png": 13000,
	"./Item_Icon_FrostIngot.png": 51777,
	"./Item_Icon_FrostIngots.png": 51550,
	"./Item_Icon_FrostOre.png": 99852,
	"./Item_Icon_FrostOres.png": 81037,
	"./Item_Icon_FrostPowder.png": 51077,
	"./Item_Icon_FrostWyvernClaws.png": 24881,
	"./Item_Icon_FrostWyvernEgg.png": 19786,
	"./Item_Icon_FrostWyvernsHide.png": 82162,
	"./Item_Icon_FrostedFeather.png": 86076,
	"./Item_Icon_FrozenHeart copy.png": 61815,
	"./Item_Icon_FrozenHeart.png": 49102,
	"./Item_Icon_FrozenIronkey.png": 37185,
	"./Item_Icon_GemNecklace copy.png": 886,
	"./Item_Icon_GemNecklace.png": 97649,
	"./Item_Icon_GemRing copy.png": 62264,
	"./Item_Icon_GemRing.png": 12367,
	"./Item_Icon_GhostlyEssence.png": 39000,
	"./Item_Icon_GiantBatEar.png": 2220,
	"./Item_Icon_GiantBatHide.png": 49990,
	"./Item_Icon_GiantToe copy.png": 67260,
	"./Item_Icon_GiantToe.png": 5107,
	"./Item_Icon_GingerbreadCookie copy.png": 55097,
	"./Item_Icon_GingerbreadCookie.png": 61892,
	"./Item_Icon_Gjermundbu_0001 copy.png": 92678,
	"./Item_Icon_Gjermundbu_0001.png": 15201,
	"./Item_Icon_Gjermundbu_1001.png": 52642,
	"./Item_Icon_Gjermundbu_2001 copy.png": 79300,
	"./Item_Icon_Gjermundbu_2001.png": 20779,
	"./Item_Icon_Gjermundbu_3001.png": 98668,
	"./Item_Icon_Gjermundbu_4001 copy.png": 64034,
	"./Item_Icon_Gjermundbu_4001.png": 80157,
	"./Item_Icon_Gjermundbu_5001 copy.png": 19303,
	"./Item_Icon_Gjermundbu_5001.png": 90942,
	"./Item_Icon_Gjermundbu_6001 copy.png": 31264,
	"./Item_Icon_Gjermundbu_6001.png": 35943,
	"./Item_Icon_Gjermundbu_7001.png": 35864,
	"./Item_Icon_GlowingBludeIceEyes copy.png": 91241,
	"./Item_Icon_GlowingBludeIceEyes.png": 79796,
	"./Item_Icon_Goblet.png": 41317,
	"./Item_Icon_GoblinEars copy.png": 21421,
	"./Item_Icon_GoblinEars.png": 32504,
	"./Item_Icon_GoldBowl copy.png": 74161,
	"./Item_Icon_GoldBowl.png": 492,
	"./Item_Icon_GoldCandelabra copy.png": 26220,
	"./Item_Icon_GoldCandelabra.png": 26467,
	"./Item_Icon_GoldCandleHolder copy.png": 82422,
	"./Item_Icon_GoldCandleHolder.png": 4369,
	"./Item_Icon_GoldCandlePlatter copy.png": 81632,
	"./Item_Icon_GoldCandlePlatter.png": 16020,
	"./Item_Icon_GoldChalice.png": 8217,
	"./Item_Icon_GoldChaliceA copy.png": 47289,
	"./Item_Icon_GoldChaliceB copy.png": 91208,
	"./Item_Icon_GoldCoin copy.png": 14248,
	"./Item_Icon_GoldCoin.png": 95199,
	"./Item_Icon_GoldCoinPurse copy.png": 39751,
	"./Item_Icon_GoldCoinPurse.png": 11934,
	"./Item_Icon_GoldCoins copy.png": 14345,
	"./Item_Icon_GoldCoins.png": 54964,
	"./Item_Icon_GoldCrown copy.png": 31916,
	"./Item_Icon_GoldCrown.png": 14947,
	"./Item_Icon_GoldGoblet.png": 70295,
	"./Item_Icon_GoldIngot copy.png": 94476,
	"./Item_Icon_GoldIngot.png": 55523,
	"./Item_Icon_GoldIngots copy.png": 91509,
	"./Item_Icon_GoldIngots.png": 75120,
	"./Item_Icon_GoldOre copy.png": 84203,
	"./Item_Icon_GoldOre.png": 67362,
	"./Item_Icon_GoldOres copy.png": 20476,
	"./Item_Icon_GoldOres.png": 92883,
	"./Item_Icon_GoldPowder copy.png": 73628,
	"./Item_Icon_GoldPowder.png": 20211,
	"./Item_Icon_GoldWaterpot copy.png": 49747,
	"./Item_Icon_GoldWaterpot.png": 62682,
	"./Item_Icon_GoldenArmet copy.png": 96097,
	"./Item_Icon_GoldenArmet.png": 79868,
	"./Item_Icon_GoldenBoots copy.png": 30071,
	"./Item_Icon_GoldenBoots.png": 18414,
	"./Item_Icon_GoldenChausses copy.png": 31365,
	"./Item_Icon_GoldenChausses.png": 27520,
	"./Item_Icon_GoldenFellingAxe copy.png": 1731,
	"./Item_Icon_GoldenFellingAxe.png": 60266,
	"./Item_Icon_GoldenGauntlet copy.png": 24980,
	"./Item_Icon_GoldenGauntlet.png": 39195,
	"./Item_Icon_GoldenGjermundbu copy.png": 62181,
	"./Item_Icon_GoldenGjermundbu.png": 20928,
	"./Item_Icon_GoldenGloves copy.png": 59748,
	"./Item_Icon_GoldenGloves.png": 61259,
	"./Item_Icon_GoldenKey copy.png": 25141,
	"./Item_Icon_GoldenKey.png": 54768,
	"./Item_Icon_GoldenLeggings copy.png": 96690,
	"./Item_Icon_GoldenLeggings.png": 33901,
	"./Item_Icon_GoldenPaddedTunic copy.png": 11415,
	"./Item_Icon_GoldenPaddedTunic.png": 49006,
	"./Item_Icon_GoldenPlate copy.png": 87970,
	"./Item_Icon_GoldenPlate.png": 5789,
	"./Item_Icon_GoldenPlateBoots copy.png": 64111,
	"./Item_Icon_GoldenPlateBoots.png": 70646,
	"./Item_Icon_GoldenPlatePants copy.png": 21336,
	"./Item_Icon_GoldenPlatePants.png": 18127,
	"./Item_Icon_GoldenRobe copy.png": 56284,
	"./Item_Icon_GoldenRobe.png": 58835,
	"./Item_Icon_GoldenSkulltoken.png": 77823,
	"./Item_Icon_GoldenTeeth copy.png": 91544,
	"./Item_Icon_GoldenTeeth.png": 77743,
	"./Item_Icon_GoldenVikingSword copy.png": 43641,
	"./Item_Icon_GoldenVikingSword.png": 22436,
	"./Item_Icon_GrandBrigandine copy.png": 6478,
	"./Item_Icon_GrandBrigandine.png": 16057,
	"./Item_Icon_GraveEssence copy.png": 64238,
	"./Item_Icon_GraveEssence.png": 49337,
	"./Item_Icon_GravewolfGloves copy.png": 95578,
	"./Item_Icon_GravewolfGloves.png": 21765,
	"./Item_Icon_GreatHelm copy.png": 90996,
	"./Item_Icon_GreatHelm.png": 32603,
	"./Item_Icon_GrimsmileRing copy.png": 49838,
	"./Item_Icon_GrimsmileRing.png": 85273,
	"./Item_Icon_Halberd_0001 copy.png": 83419,
	"./Item_Icon_Halberd_0001.png": 44754,
	"./Item_Icon_Halberd_1001.png": 10321,
	"./Item_Icon_Halberd_2001 copy.png": 16033,
	"./Item_Icon_Halberd_2001.png": 65660,
	"./Item_Icon_Halberd_3001.png": 73435,
	"./Item_Icon_Halberd_4001 copy.png": 28663,
	"./Item_Icon_Halberd_4001.png": 47374,
	"./Item_Icon_Halberd_5001 copy.png": 9458,
	"./Item_Icon_Halberd_5001.png": 84781,
	"./Item_Icon_Halberd_6001 copy.png": 9597,
	"./Item_Icon_Halberd_6001.png": 82600,
	"./Item_Icon_Halberd_7001 copy.png": 61936,
	"./Item_Icon_Halberd_7001.png": 72279,
	"./Item_Icon_HandCrossbow_0001 copy.png": 90744,
	"./Item_Icon_HandCrossbow_0001.png": 75567,
	"./Item_Icon_HandCrossbow_1001.png": 94112,
	"./Item_Icon_HandCrossbow_2001 copy.png": 7386,
	"./Item_Icon_HandCrossbow_2001.png": 11909,
	"./Item_Icon_HandCrossbow_3001.png": 42534,
	"./Item_Icon_HandCrossbow_4001 copy.png": 27740,
	"./Item_Icon_HandCrossbow_4001.png": 3667,
	"./Item_Icon_HandCrossbow_5001 copy.png": 90665,
	"./Item_Icon_HandCrossbow_5001.png": 35988,
	"./Item_Icon_HandCrossbow_6001 copy.png": 48094,
	"./Item_Icon_HandCrossbow_6001.png": 35049,
	"./Item_Icon_HandCrossbow_7001 copy.png": 92259,
	"./Item_Icon_HandCrossbow_7001.png": 95018,
	"./Item_Icon_Hatchet_0001 copy.png": 94064,
	"./Item_Icon_Hatchet_0001.png": 19895,
	"./Item_Icon_Hatchet_1001.png": 62216,
	"./Item_Icon_Hatchet_2001 copy.png": 22354,
	"./Item_Icon_Hatchet_2001.png": 98701,
	"./Item_Icon_Hatchet_3001.png": 52238,
	"./Item_Icon_Hatchet_4001 copy.png": 61396,
	"./Item_Icon_Hatchet_4001.png": 57435,
	"./Item_Icon_Hatchet_5001 copy.png": 56961,
	"./Item_Icon_Hatchet_5001.png": 51548,
	"./Item_Icon_Hatchet_6001 copy.png": 48982,
	"./Item_Icon_Hatchet_6001.png": 33745,
	"./Item_Icon_Hatchet_7001 copy.png": 42747,
	"./Item_Icon_Hatchet_7001.png": 8114,
	"./Item_Icon_HealPotion01.png": 21036,
	"./Item_Icon_HealPotion_BoneDecoratedBottle.png": 5409,
	"./Item_Icon_HealingPotion.png": 64207,
	"./Item_Icon_HeaterShield_0001 copy.png": 69271,
	"./Item_Icon_HeaterShield_0001.png": 54926,
	"./Item_Icon_HeaterShield_1001.png": 1389,
	"./Item_Icon_HeaterShield_2001 copy.png": 56957,
	"./Item_Icon_HeaterShield_2001.png": 64904,
	"./Item_Icon_HeaterShield_3001.png": 22583,
	"./Item_Icon_HeaterShield_4001 copy.png": 27067,
	"./Item_Icon_HeaterShield_4001.png": 10802,
	"./Item_Icon_HeaterShield_5001 copy.png": 16950,
	"./Item_Icon_HeaterShield_5001.png": 36433,
	"./Item_Icon_HeaterShield_6001 copy.png": 41281,
	"./Item_Icon_HeaterShield_6001.png": 54236,
	"./Item_Icon_HeaterShield_7001 copy.png": 45716,
	"./Item_Icon_HeaterShield_7001.png": 76475,
	"./Item_Icon_HeavyBoots copy.png": 16607,
	"./Item_Icon_HeavyBoots.png": 25190,
	"./Item_Icon_HeavyGambeson copy.png": 73720,
	"./Item_Icon_HeavyGambeson.png": 55375,
	"./Item_Icon_HeavyGauntlet copy.png": 48364,
	"./Item_Icon_HeavyGauntlet.png": 61891,
	"./Item_Icon_HeavyGauntlet_RS.png": 68965,
	"./Item_Icon_HeavyLeatherLeggings copy.png": 59863,
	"./Item_Icon_HeavyLeatherLeggings.png": 25806,
	"./Item_Icon_HoneyblissPear.png": 50388,
	"./Item_Icon_Hood_RS.png": 22564,
	"./Item_Icon_HorsemansAxe_0001 copy.png": 82575,
	"./Item_Icon_HorsemansAxe_0001.png": 21686,
	"./Item_Icon_HorsemansAxe_1001.png": 49077,
	"./Item_Icon_HorsemansAxe_2001 copy.png": 87829,
	"./Item_Icon_HorsemansAxe_2001.png": 98128,
	"./Item_Icon_HorsemansAxe_3001.png": 66175,
	"./Item_Icon_HorsemansAxe_4001 copy.png": 14323,
	"./Item_Icon_HorsemansAxe_4001.png": 31418,
	"./Item_Icon_HorsemansAxe_5001 copy.png": 54222,
	"./Item_Icon_HorsemansAxe_5001.png": 42073,
	"./Item_Icon_HorsemansAxe_6001 copy.png": 95321,
	"./Item_Icon_HorsemansAxe_6001.png": 95076,
	"./Item_Icon_HorsemansAxe_7001 copy.png": 89324,
	"./Item_Icon_HorsemansAxe_7001.png": 6435,
	"./Item_Icon_Hounskull copy.png": 61746,
	"./Item_Icon_Hounskull.png": 69325,
	"./Item_Icon_HumanRemains.png": 69496,
	"./Item_Icon_HuntingTrap copy.png": 89721,
	"./Item_Icon_HuntingTrap.png": 33732,
	"./Item_Icon_InfectedFlesh copy.png": 86843,
	"./Item_Icon_InfectedFlesh.png": 55122,
	"./Item_Icon_IntactSkull copy.png": 55785,
	"./Item_Icon_IntactSkull.png": 18900,
	"./Item_Icon_InvisibilityPotion copy.png": 22959,
	"./Item_Icon_InvisibilityPotion.png": 70582,
	"./Item_Icon_InvisibilityPotion_BoneDecoratedBottle.png": 84386,
	"./Item_Icon_IronIngot copy.png": 30816,
	"./Item_Icon_IronIngot.png": 59719,
	"./Item_Icon_IronIngots copy.png": 71633,
	"./Item_Icon_IronIngots.png": 5100,
	"./Item_Icon_IronOre copy.png": 70543,
	"./Item_Icon_IronOre.png": 8022,
	"./Item_Icon_IronOres copy.png": 57320,
	"./Item_Icon_IronOres.png": 68639,
	"./Item_Icon_IronPowder copy.png": 49960,
	"./Item_Icon_IronPowder.png": 91551,
	"./Item_Icon_KettleHat copy.png": 46225,
	"./Item_Icon_KettleHat.png": 12908,
	"./Item_Icon_KoboldEar copy.png": 25874,
	"./Item_Icon_KoboldEar.png": 60173,
	"./Item_Icon_KrisDagger_0001 copy.png": 25034,
	"./Item_Icon_KrisDagger_0001.png": 15797,
	"./Item_Icon_KrisDagger_1001.png": 81078,
	"./Item_Icon_KrisDagger_2001 copy.png": 98408,
	"./Item_Icon_KrisDagger_2001.png": 32895,
	"./Item_Icon_KrisDagger_3001.png": 34224,
	"./Item_Icon_KrisDagger_4001 copy.png": 62382,
	"./Item_Icon_KrisDagger_4001.png": 25145,
	"./Item_Icon_KrisDagger_5001 copy.png": 2099,
	"./Item_Icon_KrisDagger_5001.png": 67514,
	"./Item_Icon_KrisDagger_6001 copy.png": 42924,
	"./Item_Icon_KrisDagger_6001.png": 96451,
	"./Item_Icon_KrisDagger_7001 copy.png": 3705,
	"./Item_Icon_KrisDagger_7001.png": 27620,
	"./Item_Icon_LacedTurnshoe copy.png": 43968,
	"./Item_Icon_LacedTurnshoe.png": 87783,
	"./Item_Icon_Lantern_1001.png": 96195,
	"./Item_Icon_Lantern_2001 copy.png": 29299,
	"./Item_Icon_Lantern_2001.png": 21178,
	"./Item_Icon_Lantern_3001.png": 31833,
	"./Item_Icon_Lantern_4001.png": 87888,
	"./Item_Icon_Lantern_5001.png": 55935,
	"./Item_Icon_Lantern_6001.png": 11446,
	"./Item_Icon_Lantern_7001.png": 22485,
	"./Item_Icon_LargeScroll copy.png": 72563,
	"./Item_Icon_LargeScroll.png": 24250,
	"./Item_Icon_LeatherBonnet copy.png": 95922,
	"./Item_Icon_LeatherBonnet.png": 90349,
	"./Item_Icon_LeatherCap copy.png": 15700,
	"./Item_Icon_LeatherCap.png": 4891,
	"./Item_Icon_LeatherCap_RS.png": 64861,
	"./Item_Icon_LeatherChausses copy.png": 55511,
	"./Item_Icon_LeatherChausses.png": 9966,
	"./Item_Icon_LeatherGloves copy.png": 27926,
	"./Item_Icon_LeatherGloves.png": 62897,
	"./Item_Icon_LeatherLeggings copy.png": 42680,
	"./Item_Icon_LeatherLeggings.png": 83503,
	"./Item_Icon_LeatherLeggings_RS.png": 12049,
	"./Item_Icon_Lifeleaf copy.png": 90449,
	"./Item_Icon_Lifeleaf.png": 70220,
	"./Item_Icon_LightAketon copy.png": 93653,
	"./Item_Icon_LightAketon.png": 97360,
	"./Item_Icon_LightBringer copy.png": 34688,
	"./Item_Icon_LightBringer.png": 14823,
	"./Item_Icon_LightGauntlets copy.png": 27992,
	"./Item_Icon_LightGauntlets.png": 46543,
	"./Item_Icon_LightfootBoots copy.png": 21026,
	"./Item_Icon_LightfootBoots.png": 16253,
	"./Item_Icon_Lockpick copy.png": 56029,
	"./Item_Icon_Lockpick.png": 63304,
	"./Item_Icon_Longbow_0001 copy.png": 33467,
	"./Item_Icon_Longbow_0001.png": 55026,
	"./Item_Icon_Longbow_1001.png": 67569,
	"./Item_Icon_Longbow_2001 copy.png": 32481,
	"./Item_Icon_Longbow_2001.png": 57084,
	"./Item_Icon_Longbow_3001.png": 14331,
	"./Item_Icon_Longbow_4001 copy.png": 31863,
	"./Item_Icon_Longbow_4001.png": 64974,
	"./Item_Icon_Longbow_5001 copy.png": 10034,
	"./Item_Icon_Longbow_5001.png": 99501,
	"./Item_Icon_Longbow_6001 copy.png": 65597,
	"./Item_Icon_Longbow_6001.png": 74024,
	"./Item_Icon_Longbow_7001 copy.png": 8080,
	"./Item_Icon_Longbow_7001.png": 13175,
	"./Item_Icon_Longsword_0001 copy.png": 91104,
	"./Item_Icon_Longsword_0001.png": 391,
	"./Item_Icon_Longsword_1001.png": 95864,
	"./Item_Icon_Longsword_2001 copy.png": 90178,
	"./Item_Icon_Longsword_2001.png": 40157,
	"./Item_Icon_Longsword_3001.png": 50942,
	"./Item_Icon_Longsword_4001 copy.png": 4868,
	"./Item_Icon_Longsword_4001.png": 85227,
	"./Item_Icon_Longsword_5001 copy.png": 66385,
	"./Item_Icon_Longsword_5001.png": 5644,
	"./Item_Icon_Longsword_6001 copy.png": 88518,
	"./Item_Icon_Longsword_6001.png": 98881,
	"./Item_Icon_Longsword_7001 copy.png": 76491,
	"./Item_Icon_Longsword_7001.png": 19970,
	"./Item_Icon_LooseTrousers copy.png": 25534,
	"./Item_Icon_LooseTrousers.png": 38921,
	"./Item_Icon_LowBoots copy.png": 32583,
	"./Item_Icon_LowBoots.png": 54619,
	"./Item_Icon_LuckPotion copy.png": 56345,
	"./Item_Icon_LuckPotion.png": 62116,
	"./Item_Icon_LuckPotionGreat copy.png": 94782,
	"./Item_Icon_LuckPotionGreat.png": 31945,
	"./Item_Icon_LuckPotionGreat_BoneDecoratedBottle.png": 93981,
	"./Item_Icon_LuckPotion_BoneDecoratedBottle.png": 60180,
	"./Item_Icon_Lute_0001 copy.png": 17579,
	"./Item_Icon_Lute_0001.png": 54594,
	"./Item_Icon_Lute_1001.png": 45665,
	"./Item_Icon_Lute_2001 copy.png": 81713,
	"./Item_Icon_Lute_2001.png": 77548,
	"./Item_Icon_Lute_3001.png": 44267,
	"./Item_Icon_Lute_4001 copy.png": 47431,
	"./Item_Icon_Lute_4001.png": 62270,
	"./Item_Icon_Lute_5001 copy.png": 9378,
	"./Item_Icon_Lute_5001.png": 56381,
	"./Item_Icon_Lute_6001 copy.png": 53037,
	"./Item_Icon_Lute_6001.png": 50872,
	"./Item_Icon_Lute_7001.png": 68359,
	"./Item_Icon_Lyre_0001 copy.png": 17489,
	"./Item_Icon_Lyre_0001.png": 8895,
	"./Item_Icon_Lyre_1001.png": 44971,
	"./Item_Icon_Lyre_2001 copy.png": 37099,
	"./Item_Icon_Lyre_2001.png": 85026,
	"./Item_Icon_Lyre_3001.png": 18625,
	"./Item_Icon_Lyre_4001 copy.png": 90669,
	"./Item_Icon_Lyre_4001.png": 54456,
	"./Item_Icon_Lyre_5001 copy.png": 71424,
	"./Item_Icon_Lyre_5001.png": 48263,
	"./Item_Icon_Lyre_6001 copy.png": 29383,
	"./Item_Icon_Lyre_6001.png": 89150,
	"./Item_Icon_Lyre_7001.png": 86813,
	"./Item_Icon_Maggots copy.png": 22085,
	"./Item_Icon_Maggots.png": 16192,
	"./Item_Icon_MagicProtectionPotion copy.png": 4798,
	"./Item_Icon_MagicProtectionPotion.png": 70921,
	"./Item_Icon_MagicProtectionPotion_BoneDecoratedBottle.png": 90973,
	"./Item_Icon_MagicWand copy.png": 32404,
	"./Item_Icon_MagicWand.png": 36603,
	"./Item_Icon_ManaSphere copy.png": 47921,
	"./Item_Icon_ManaSphere.png": 77772,
	"./Item_Icon_ManuscriptsoftheWarlord.png": 25983,
	"./Item_Icon_MarauderOutfit copy.png": 84549,
	"./Item_Icon_MarauderOutfit.png": 22560,
	"./Item_Icon_MercurialCloak copy.png": 30283,
	"./Item_Icon_MercurialCloak.png": 70178,
	"./Item_Icon_MetalCup.png": 6969,
	"./Item_Icon_MimicTongue copy.png": 2664,
	"./Item_Icon_MimicTongue.png": 96767,
	"./Item_Icon_MimicTooth copy.png": 96094,
	"./Item_Icon_MimicTooth.png": 70985,
	"./Item_Icon_MoldyBread copy.png": 7260,
	"./Item_Icon_MoldyBread.png": 11027,
	"./Item_Icon_MonkeyPendant copy.png": 55148,
	"./Item_Icon_MonkeyPendant.png": 73571,
	"./Item_Icon_MoonlightAdventurerCloak copy.png": 33384,
	"./Item_Icon_MoonlightAdventurerCloak.png": 37855,
	"./Item_Icon_MoonlightMercurialCloak copy.png": 92906,
	"./Item_Icon_MoonlightMercurialCloak.png": 20629,
	"./Item_Icon_MoonlightSplendidCloak copy.png": 1863,
	"./Item_Icon_MoonlightSplendidCloak.png": 84446,
	"./Item_Icon_MoonlightTatteredCloak copy.png": 52925,
	"./Item_Icon_MoonlightTatteredCloak.png": 78664,
	"./Item_Icon_MoonlightVigilantCloak copy.png": 6430,
	"./Item_Icon_MoonlightVigilantCloak.png": 16169,
	"./Item_Icon_MoonlightWatchmanCloak copy.png": 69493,
	"./Item_Icon_MoonlightWatchmanCloak.png": 18128,
	"./Item_Icon_Morningstar_0001 copy.png": 39805,
	"./Item_Icon_Morningstar_0001.png": 4904,
	"./Item_Icon_Morningstar_1001.png": 60407,
	"./Item_Icon_Morningstar_2001 copy.png": 6071,
	"./Item_Icon_Morningstar_2001.png": 12206,
	"./Item_Icon_Morningstar_3001.png": 30381,
	"./Item_Icon_Morningstar_4001 copy.png": 90337,
	"./Item_Icon_Morningstar_4001.png": 87964,
	"./Item_Icon_Morningstar_5001 copy.png": 51636,
	"./Item_Icon_Morningstar_5001.png": 61563,
	"./Item_Icon_Morningstar_6001 copy.png": 7675,
	"./Item_Icon_Morningstar_6001.png": 2258,
	"./Item_Icon_Morningstar_7001 copy.png": 40470,
	"./Item_Icon_Morningstar_7001.png": 98449,
	"./Item_Icon_MysticGloves copy.png": 19960,
	"./Item_Icon_MysticGloves.png": 48783,
	"./Item_Icon_MysticVestments copy.png": 68025,
	"./Item_Icon_MysticVestments.png": 23428,
	"./Item_Icon_MysticVestments_RS.png": 37556,
	"./Item_Icon_MysticalGem copy.png": 40514,
	"./Item_Icon_MysticalGem.png": 77661,
	"./Item_Icon_Necklace01.png": 89147,
	"./Item_Icon_NecklaceOfPeace.png": 51987,
	"./Item_Icon_NormanNasalHelm copy.png": 53501,
	"./Item_Icon_NormanNasalHelm.png": 2888,
	"./Item_Icon_NorthernFullTunic copy.png": 18396,
	"./Item_Icon_NorthernFullTunic.png": 75254,
	"./Item_Icon_OccultistBoots copy.png": 16572,
	"./Item_Icon_OccultistBoots.png": 2291,
	"./Item_Icon_OccultistHood copy.png": 63729,
	"./Item_Icon_OccultistHood.png": 66828,
	"./Item_Icon_OccultistPants copy.png": 83679,
	"./Item_Icon_OccultistPants.png": 78214,
	"./Item_Icon_OccultistRobe copy.png": 17941,
	"./Item_Icon_OccultistRobe.png": 97392,
	"./Item_Icon_OccultistTunic copy.png": 3226,
	"./Item_Icon_OccultistTunic.png": 58405,
	"./Item_Icon_OilLantern copy.png": 88079,
	"./Item_Icon_OilLantern.png": 12726,
	"./Item_Icon_OldBloodyBandage.png": 64422,
	"./Item_Icon_OldCloth copy.png": 2704,
	"./Item_Icon_OldCloth.png": 48823,
	"./Item_Icon_OldRustyKey copy.png": 56760,
	"./Item_Icon_OldRustyKey.png": 18191,
	"./Item_Icon_OldShoes copy.png": 15804,
	"./Item_Icon_OldShoes.png": 13171,
	"./Item_Icon_OpenSallet copy.png": 46482,
	"./Item_Icon_OpenSallet.png": 24109,
	"./Item_Icon_OracleRobe copy.png": 82219,
	"./Item_Icon_OracleRobe.png": 8066,
	"./Item_Icon_OrnateJazerant copy.png": 80951,
	"./Item_Icon_OrnateJazerant.png": 15950,
	"./Item_Icon_OwlPendant copy.png": 87415,
	"./Item_Icon_OwlPendant.png": 77102,
	"./Item_Icon_OxPendant copy.png": 37182,
	"./Item_Icon_OxPendant.png": 38409,
	"./Item_Icon_PaddedLeggings copy.png": 43765,
	"./Item_Icon_PaddedLeggings.png": 57904,
	"./Item_Icon_PaddedTunic copy.png": 21192,
	"./Item_Icon_PaddedTunic.png": 54911,
	"./Item_Icon_Pavise_0001 copy.png": 79653,
	"./Item_Icon_Pavise_0001.png": 99072,
	"./Item_Icon_Pavise_1001.png": 17871,
	"./Item_Icon_Pavise_2001 copy.png": 31423,
	"./Item_Icon_Pavise_2001.png": 67558,
	"./Item_Icon_Pavise_3001.png": 38053,
	"./Item_Icon_Pavise_4001 copy.png": 47753,
	"./Item_Icon_Pavise_4001.png": 21044,
	"./Item_Icon_Pavise_5001 copy.png": 72092,
	"./Item_Icon_Pavise_5001.png": 43411,
	"./Item_Icon_Pavise_6001 copy.png": 17603,
	"./Item_Icon_Pavise_6001.png": 72106,
	"./Item_Icon_Pavise_7001 copy.png": 98238,
	"./Item_Icon_Pavise_7001.png": 9033,
	"./Item_Icon_PearlNecklace copy.png": 54765,
	"./Item_Icon_PearlNecklace.png": 98552,
	"./Item_Icon_PhantomFlower copy.png": 92223,
	"./Item_Icon_PhantomFlower.png": 71750,
	"./Item_Icon_PhoenixChoker.png": 20283,
	"./Item_Icon_Pickaxe_0001 copy.png": 87416,
	"./Item_Icon_Pickaxe_0001.png": 47599,
	"./Item_Icon_Pickaxe_1001.png": 73088,
	"./Item_Icon_Pickaxe_2001.png": 54213,
	"./Item_Icon_Pickaxe_3001.png": 80390,
	"./Item_Icon_Pickaxe_4001.png": 25171,
	"./Item_Icon_Pickaxe_5001.png": 78292,
	"./Item_Icon_Pickaxe_6001.png": 30377,
	"./Item_Icon_Pickaxe_7001.png": 9578,
	"./Item_Icon_PlateBoots copy.png": 80766,
	"./Item_Icon_PlateBoots.png": 84073,
	"./Item_Icon_PlateBoots_RS.png": 74723,
	"./Item_Icon_PlatePants copy.png": 705,
	"./Item_Icon_PlatePants.png": 30076,
	"./Item_Icon_PlatePants_RS.png": 55308,
	"./Item_Icon_PotionAndBandage.png": 7380,
	"./Item_Icon_Poupoint copy.png": 67961,
	"./Item_Icon_Poupoint.png": 73764,
	"./Item_Icon_PrimitiveBracelet.png": 1715,
	"./Item_Icon_ProtectionPotion copy.png": 21271,
	"./Item_Icon_ProtectionPotion.png": 95310,
	"./Item_Icon_ProtectionPotion_BoneDecoratedBottle.png": 29114,
	"./Item_Icon_Quarterstaff_0001 copy.png": 15705,
	"./Item_Icon_Quarterstaff_0001.png": 13348,
	"./Item_Icon_Quarterstaff_1001.png": 99299,
	"./Item_Icon_Quarterstaff_2001 copy.png": 6387,
	"./Item_Icon_Quarterstaff_2001.png": 44634,
	"./Item_Icon_Quarterstaff_3001.png": 8537,
	"./Item_Icon_Quarterstaff_4001 copy.png": 20821,
	"./Item_Icon_Quarterstaff_4001.png": 72528,
	"./Item_Icon_Quarterstaff_5001 copy.png": 61096,
	"./Item_Icon_Quarterstaff_5001.png": 79647,
	"./Item_Icon_Quarterstaff_6001 copy.png": 35951,
	"./Item_Icon_Quarterstaff_6001.png": 36982,
	"./Item_Icon_Quarterstaff_7001 copy.png": 72330,
	"./Item_Icon_Quarterstaff_7001.png": 49685,
	"./Item_Icon_Quiver_Empty copy.png": 90247,
	"./Item_Icon_Quiver_Empty.png": 65598,
	"./Item_Icon_RangerHood copy.png": 17556,
	"./Item_Icon_RangerHood.png": 12955,
	"./Item_Icon_Rapier_0001 copy.png": 13356,
	"./Item_Icon_Rapier_0001.png": 80259,
	"./Item_Icon_Rapier_1001.png": 68900,
	"./Item_Icon_Rapier_2001 copy.png": 61902,
	"./Item_Icon_Rapier_2001.png": 15897,
	"./Item_Icon_Rapier_3001.png": 5242,
	"./Item_Icon_Rapier_4001 copy.png": 68936,
	"./Item_Icon_Rapier_4001.png": 39999,
	"./Item_Icon_Rapier_5001 copy.png": 95509,
	"./Item_Icon_Rapier_5001.png": 71952,
	"./Item_Icon_Rapier_6001 copy.png": 93162,
	"./Item_Icon_Rapier_6001.png": 6549,
	"./Item_Icon_Rapier_7001 copy.png": 90255,
	"./Item_Icon_Rapier_7001.png": 95510,
	"./Item_Icon_RatPendant copy.png": 18408,
	"./Item_Icon_RatPendant.png": 34559,
	"./Item_Icon_RawhideGloves copy.png": 44549,
	"./Item_Icon_RawhideGloves.png": 54112,
	"./Item_Icon_RawhideGloves_RS.png": 37984,
	"./Item_Icon_RecurveBow_0001 copy.png": 7123,
	"./Item_Icon_RecurveBow_0001.png": 65978,
	"./Item_Icon_RecurveBow_1001.png": 7257,
	"./Item_Icon_RecurveBow_2001 copy.png": 25081,
	"./Item_Icon_RecurveBow_2001.png": 26084,
	"./Item_Icon_RecurveBow_3001.png": 78563,
	"./Item_Icon_RecurveBow_4001 copy.png": 87183,
	"./Item_Icon_RecurveBow_4001.png": 63190,
	"./Item_Icon_RecurveBow_5001 copy.png": 30058,
	"./Item_Icon_RecurveBow_5001.png": 97909,
	"./Item_Icon_RecurveBow_6001 copy.png": 96565,
	"./Item_Icon_RecurveBow_6001.png": 16336,
	"./Item_Icon_RecurveBow_7001 copy.png": 19784,
	"./Item_Icon_RecurveBow_7001.png": 31359,
	"./Item_Icon_RegalGambeson copy.png": 5780,
	"./Item_Icon_RegalGambeson.png": 20411,
	"./Item_Icon_ReinforcedGloves copy.png": 34258,
	"./Item_Icon_ReinforcedGloves.png": 61389,
	"./Item_Icon_RewardToken.png": 99140,
	"./Item_Icon_RingOfCourage.png": 16283,
	"./Item_Icon_RingOfQuickness.png": 9943,
	"./Item_Icon_RingOfResolve.png": 77547,
	"./Item_Icon_RingOfSurvival.png": 70317,
	"./Item_Icon_RingofFinesse copy.png": 50329,
	"./Item_Icon_RingofFinesse.png": 95620,
	"./Item_Icon_RingofVitality copy.png": 94638,
	"./Item_Icon_RingofVitality.png": 14649,
	"./Item_Icon_RingofWisdom copy.png": 35367,
	"./Item_Icon_RingofWisdom.png": 7262,
	"./Item_Icon_RitualRobe.png": 93677,
	"./Item_Icon_RivetedGloves copy.png": 74266,
	"./Item_Icon_RivetedGloves.png": 68165,
	"./Item_Icon_RobeofDarkness copy.png": 30755,
	"./Item_Icon_RobeofDarkness.png": 85738,
	"./Item_Icon_RodofRighteousness copy.png": 13446,
	"./Item_Icon_RodofRighteousness.png": 91681,
	"./Item_Icon_RogueCowl copy.png": 70842,
	"./Item_Icon_RogueCowl.png": 20645,
	"./Item_Icon_RondelDagger_0001 copy.png": 19421,
	"./Item_Icon_RondelDagger_0001.png": 16680,
	"./Item_Icon_RondelDagger_1001.png": 2103,
	"./Item_Icon_RondelDagger_2001 copy.png": 35863,
	"./Item_Icon_RondelDagger_2001.png": 23054,
	"./Item_Icon_RondelDagger_3001.png": 50285,
	"./Item_Icon_RondelDagger_4001 copy.png": 42145,
	"./Item_Icon_RondelDagger_4001.png": 10460,
	"./Item_Icon_RondelDagger_5001 copy.png": 95956,
	"./Item_Icon_RondelDagger_5001.png": 58875,
	"./Item_Icon_RondelDagger_6001 copy.png": 76891,
	"./Item_Icon_RondelDagger_6001.png": 83378,
	"./Item_Icon_RondelDagger_7001 copy.png": 53462,
	"./Item_Icon_RondelDagger_7001.png": 62033,
	"./Item_Icon_RottenFluides copy.png": 54137,
	"./Item_Icon_RottenFluides.png": 21764,
	"./Item_Icon_RottenFluids.png": 10793,
	"./Item_Icon_RoundShield_0001 copy.png": 95162,
	"./Item_Icon_RoundShield_0001.png": 75333,
	"./Item_Icon_RoundShield_1001.png": 75110,
	"./Item_Icon_RoundShield_2001 copy.png": 59352,
	"./Item_Icon_RoundShield_2001.png": 44655,
	"./Item_Icon_RoundShield_3001.png": 6624,
	"./Item_Icon_RoundShield_4001 copy.png": 14270,
	"./Item_Icon_RoundShield_4001.png": 59113,
	"./Item_Icon_RoundShield_5001 copy.png": 95011,
	"./Item_Icon_RoundShield_5001.png": 25738,
	"./Item_Icon_RoundShield_6001 copy.png": 90204,
	"./Item_Icon_RoundShield_6001.png": 70195,
	"./Item_Icon_RoundShield_7001 copy.png": 90409,
	"./Item_Icon_RoundShield_7001.png": 71124,
	"./Item_Icon_Ruby copy.png": 62927,
	"./Item_Icon_Ruby.png": 79510,
	"./Item_Icon_RubysilverAdventurerBoots copy.png": 73853,
	"./Item_Icon_RubysilverAdventurerBoots.png": 2280,
	"./Item_Icon_RubysilverBarbutaHelm copy.png": 91349,
	"./Item_Icon_RubysilverBarbutaHelm.png": 78704,
	"./Item_Icon_RubysilverDoublet copy.png": 32993,
	"./Item_Icon_RubysilverDoublet.png": 66780,
	"./Item_Icon_RubysilverFineCuirass copy.png": 45858,
	"./Item_Icon_RubysilverFineCuirass.png": 95773,
	"./Item_Icon_RubysilverHeavyGauntlet copy.png": 78195,
	"./Item_Icon_RubysilverHeavyGauntlet.png": 698,
	"./Item_Icon_RubysilverHood copy.png": 85768,
	"./Item_Icon_RubysilverHood.png": 75551,
	"./Item_Icon_RubysilverIngot copy.png": 30837,
	"./Item_Icon_RubysilverIngot.png": 70832,
	"./Item_Icon_RubysilverIngots copy.png": 30622,
	"./Item_Icon_RubysilverIngots.png": 42185,
	"./Item_Icon_RubysilverLeatherCap copy.png": 84605,
	"./Item_Icon_RubysilverLeatherCap.png": 58664,
	"./Item_Icon_RubysilverLeatherLeggings copy.png": 29243,
	"./Item_Icon_RubysilverLeatherLeggings.png": 7602,
	"./Item_Icon_RubysilverMysticVestments copy.png": 16158,
	"./Item_Icon_RubysilverMysticVestments.png": 26409,
	"./Item_Icon_RubysilverOre copy.png": 36186,
	"./Item_Icon_RubysilverOre.png": 66117,
	"./Item_Icon_RubysilverOres copy.png": 80739,
	"./Item_Icon_RubysilverOres.png": 22730,
	"./Item_Icon_RubysilverPlateBoots copy.png": 72803,
	"./Item_Icon_RubysilverPlateBoots.png": 96778,
	"./Item_Icon_RubysilverPlatePants copy.png": 51300,
	"./Item_Icon_RubysilverPlatePants.png": 98571,
	"./Item_Icon_RubysilverPowder copy.png": 55795,
	"./Item_Icon_RubysilverPowder.png": 3802,
	"./Item_Icon_RubysilverRawhideGloves copy.png": 88486,
	"./Item_Icon_RubysilverRawhideGloves.png": 62209,
	"./Item_Icon_RuggedBoots copy.png": 794,
	"./Item_Icon_RuggedBoots.png": 13061,
	"./Item_Icon_RunestoneGloves copy.png": 38010,
	"./Item_Icon_RunestoneGloves.png": 97765,
	"./Item_Icon_RustyBrokenSword copy.png": 39158,
	"./Item_Icon_RustyBrokenSword.png": 68785,
	"./Item_Icon_SM_Bangle_01a copy.png": 2432,
	"./Item_Icon_SM_Bangle_01a.png": 14567,
	"./Item_Icon_SM_Bangle_01b copy.png": 36657,
	"./Item_Icon_SM_Bangle_01b.png": 46092,
	"./Item_Icon_SM_Bangle_01c copy.png": 16426,
	"./Item_Icon_SM_Bangle_01c.png": 28981,
	"./Item_Icon_SM_Bangle_01d copy.png": 13267,
	"./Item_Icon_SM_Bangle_01d.png": 54682,
	"./Item_Icon_SM_Bangle_01e copy.png": 85356,
	"./Item_Icon_SM_Bangle_01e.png": 76259,
	"./Item_Icon_SM_Bangle_01h copy.png": 83727,
	"./Item_Icon_SM_Bangle_01h.png": 67862,
	"./Item_Icon_SM_Bangle_01i copy.png": 60680,
	"./Item_Icon_SM_Bangle_01i.png": 45951,
	"./Item_Icon_SM_Bangle_01j copy.png": 33113,
	"./Item_Icon_SM_Bangle_01j.png": 16036,
	"./Item_Icon_SM_Bangle_02d copy.png": 21348,
	"./Item_Icon_SM_Bangle_02d.png": 80651,
	"./Item_Icon_SM_Bangle_02g copy.png": 49653,
	"./Item_Icon_SM_Bangle_02g.png": 27152,
	"./Item_Icon_SM_Bangle_02h copy.png": 81520,
	"./Item_Icon_SM_Bangle_02h.png": 77687,
	"./Item_Icon_Sallet copy.png": 27366,
	"./Item_Icon_Sallet.png": 91553,
	"./Item_Icon_ShadowHood copy.png": 27321,
	"./Item_Icon_ShadowHood.png": 94884,
	"./Item_Icon_ShadowMask copy.png": 57515,
	"./Item_Icon_ShadowMask.png": 2178,
	"./Item_Icon_ShoesofDarkness copy.png": 21999,
	"./Item_Icon_ShoesofDarkness.png": 56502,
	"./Item_Icon_ShortSword_0001 copy.png": 5246,
	"./Item_Icon_ShortSword_0001.png": 11145,
	"./Item_Icon_ShortSword_1001.png": 77770,
	"./Item_Icon_ShortSword_2001 copy.png": 81180,
	"./Item_Icon_ShortSword_2001.png": 38579,
	"./Item_Icon_ShortSword_3001.png": 23156,
	"./Item_Icon_ShortSword_4001 copy.png": 86138,
	"./Item_Icon_ShortSword_4001.png": 43717,
	"./Item_Icon_ShortSword_5001 copy.png": 88735,
	"./Item_Icon_ShortSword_5001.png": 43494,
	"./Item_Icon_ShortSword_6001 copy.png": 50328,
	"./Item_Icon_ShortSword_6001.png": 13039,
	"./Item_Icon_ShortSword_7001 copy.png": 41861,
	"./Item_Icon_ShortSword_7001.png": 58656,
	"./Item_Icon_ShortSwordofRighteousness copy.png": 77894,
	"./Item_Icon_ShortSwordofRighteousness.png": 44673,
	"./Item_Icon_SilverChalice copy.png": 92303,
	"./Item_Icon_SilverChalice.png": 6454,
	"./Item_Icon_SilverCoin copy.png": 97647,
	"./Item_Icon_SilverCoin.png": 73878,
	"./Item_Icon_SilverIngot copy.png": 4653,
	"./Item_Icon_SilverIngot.png": 14104,
	"./Item_Icon_SilverIngots copy.png": 12550,
	"./Item_Icon_SilverIngots.png": 29409,
	"./Item_Icon_SilverOre copy.png": 92690,
	"./Item_Icon_SilverOre.png": 16493,
	"./Item_Icon_SilverOres copy.png": 38731,
	"./Item_Icon_SilverOres.png": 66338,
	"./Item_Icon_SilverPowder copy.png": 96699,
	"./Item_Icon_SilverPowder.png": 48146,
	"./Item_Icon_SilverSkulltoken.png": 39939,
	"./Item_Icon_SkullKey copy.png": 88295,
	"./Item_Icon_SkullKey.png": 81598,
	"./Item_Icon_SoulHeart copy.png": 17824,
	"./Item_Icon_SoulHeart.png": 34375,
	"./Item_Icon_SoulHeart_TaintedHeart.png": 96265,
	"./Item_Icon_SoulTorq.png": 96035,
	"./Item_Icon_Spangenhelm copy.png": 3243,
	"./Item_Icon_Spangenhelm.png": 75938,
	"./Item_Icon_Spear_0001 copy.png": 68998,
	"./Item_Icon_Spear_0001.png": 96129,
	"./Item_Icon_Spear_1001.png": 33570,
	"./Item_Icon_Spear_2001 copy.png": 55620,
	"./Item_Icon_Spear_2001.png": 1707,
	"./Item_Icon_Spear_3001.png": 95948,
	"./Item_Icon_Spear_4001 copy.png": 40354,
	"./Item_Icon_Spear_4001.png": 61085,
	"./Item_Icon_Spear_5001 copy.png": 95623,
	"./Item_Icon_Spear_5001.png": 71870,
	"./Item_Icon_Spear_6001 copy.png": 7584,
	"./Item_Icon_Spear_6001.png": 16871,
	"./Item_Icon_Spear_7001 copy.png": 18733,
	"./Item_Icon_Spear_7001.png": 16792,
	"./Item_Icon_SpearofRot copy.png": 62574,
	"./Item_Icon_SpearofRot.png": 89625,
	"./Item_Icon_SpectralCoinbag.png": 38255,
	"./Item_Icon_SpectralFabric.png": 14361,
	"./Item_Icon_SpectralHilt.png": 46727,
	"./Item_Icon_SpellBook_0001 copy.png": 57420,
	"./Item_Icon_SpellBook_0001.png": 64355,
	"./Item_Icon_SpellBook_1001.png": 69348,
	"./Item_Icon_SpellBook_2001 copy.png": 22318,
	"./Item_Icon_SpellBook_2001.png": 16345,
	"./Item_Icon_SpellBook_3001.png": 5690,
	"./Item_Icon_SpellBook_4001 copy.png": 90619,
	"./Item_Icon_SpellBook_4001.png": 24095,
	"./Item_Icon_SpellBook_5001 copy.png": 55925,
	"./Item_Icon_SpellBook_5001.png": 56048,
	"./Item_Icon_SpellBook_6001 copy.png": 53578,
	"./Item_Icon_SpellBook_6001.png": 6997,
	"./Item_Icon_SpellBook_7001 copy.png": 50671,
	"./Item_Icon_SpellBook_7001.png": 95958,
	"./Item_Icon_SpiderSilk copy.png": 82207,
	"./Item_Icon_SpiderSilk.png": 27270,
	"./Item_Icon_SplendidCloak copy.png": 83756,
	"./Item_Icon_SplendidCloak.png": 19875,
	"./Item_Icon_StaffofRighteousness copy.png": 24096,
	"./Item_Icon_StaffofRighteousness.png": 67482,
	"./Item_Icon_SterlingAxe copy.png": 88365,
	"./Item_Icon_SterlingAxe.png": 16728,
	"./Item_Icon_SterlingBlade copy.png": 84443,
	"./Item_Icon_SterlingBlade.png": 35442,
	"./Item_Icon_SterlingBow copy.png": 37113,
	"./Item_Icon_SterlingBow.png": 4036,
	"./Item_Icon_SterlingDagger copy.png": 34837,
	"./Item_Icon_SterlingDagger.png": 60528,
	"./Item_Icon_SterlingRod copy.png": 4232,
	"./Item_Icon_SterlingRod.png": 97887,
	"./Item_Icon_SterlingShortSword copy.png": 56632,
	"./Item_Icon_SterlingShortSword.png": 36751,
	"./Item_Icon_SterlingStaff copy.png": 93307,
	"./Item_Icon_SterlingStaff.png": 7378,
	"./Item_Icon_StilettoDagger_0001 copy.png": 44215,
	"./Item_Icon_StilettoDagger_0001.png": 81326,
	"./Item_Icon_StilettoDagger_1001.png": 15853,
	"./Item_Icon_StilettoDagger_2001 copy.png": 61597,
	"./Item_Icon_StilettoDagger_2001.png": 90376,
	"./Item_Icon_StilettoDagger_3001.png": 29527,
	"./Item_Icon_StilettoDagger_4001 copy.png": 45819,
	"./Item_Icon_StilettoDagger_4001.png": 71378,
	"./Item_Icon_StilettoDagger_5001 copy.png": 62262,
	"./Item_Icon_StilettoDagger_5001.png": 83921,
	"./Item_Icon_StilettoDagger_6001 copy.png": 28481,
	"./Item_Icon_StilettoDagger_6001.png": 73436,
	"./Item_Icon_StilettoDagger_7001 copy.png": 89780,
	"./Item_Icon_StilettoDagger_7001.png": 30683,
	"./Item_Icon_StitchedTurnshoe copy.png": 83831,
	"./Item_Icon_StitchedTurnshoe.png": 11790,
	"./Item_Icon_StrawHat copy.png": 23727,
	"./Item_Icon_StrawHat.png": 76726,
	"./Item_Icon_StuddedLeather copy.png": 61035,
	"./Item_Icon_StuddedLeather.png": 53282,
	"./Item_Icon_SurgicalKit copy.png": 82283,
	"./Item_Icon_SurgicalKit.png": 24194,
	"./Item_Icon_SurvivalBow_0001 copy.png": 51187,
	"./Item_Icon_SurvivalBow_0001.png": 63802,
	"./Item_Icon_SurvivalBow_1001.png": 21433,
	"./Item_Icon_SurvivalBow_2001 copy.png": 69145,
	"./Item_Icon_SurvivalBow_2001.png": 40260,
	"./Item_Icon_SurvivalBow_3001.png": 92739,
	"./Item_Icon_SurvivalBow_4001 copy.png": 69980,
	"./Item_Icon_SurvivalBow_4001.png": 77366,
	"./Item_Icon_SurvivalBow_5001 copy.png": 90474,
	"./Item_Icon_SurvivalBow_5001.png": 12085,
	"./Item_Icon_SurvivalBow_6001 copy.png": 56981,
	"./Item_Icon_SurvivalBow_6001.png": 30512,
	"./Item_Icon_SurvivalBow_7001 copy.png": 63848,
	"./Item_Icon_SurvivalBow_7001.png": 29183,
	"./Item_Icon_TatteredCloak copy.png": 3534,
	"./Item_Icon_TatteredCloak.png": 83033,
	"./Item_Icon_TemplarArmor copy.png": 16295,
	"./Item_Icon_TemplarArmor.png": 71262,
	"./Item_Icon_ThrowingKnife copy.png": 29512,
	"./Item_Icon_ThrowingKnife.png": 55007,
	"./Item_Icon_TokenOfHonor copy.png": 49759,
	"./Item_Icon_TokenOfHonor.png": 94502,
	"./Item_Icon_Topfhelm copy.png": 26528,
	"./Item_Icon_Topfhelm.png": 92743,
	"./Item_Icon_Torch copy.png": 94459,
	"./Item_Icon_Torch.png": 28850,
	"./Item_Icon_TorchBlue copy.png": 72551,
	"./Item_Icon_TorchBlue.png": 71006,
	"./Item_Icon_TorchPurple copy.png": 41941,
	"./Item_Icon_TorchPurple.png": 33360,
	"./Item_Icon_TorchYellow copy.png": 8311,
	"./Item_Icon_TorchYellow.png": 45486,
	"./Item_Icon_TornBatWing.png": 16813,
	"./Item_Icon_TrapDisarmingKit copy.png": 55030,
	"./Item_Icon_TrapDisarmingKit.png": 113,
	"./Item_Icon_TriPeltDoublet copy.png": 76338,
	"./Item_Icon_TriPeltDoublet.png": 1037,
	"./Item_Icon_TriPeltNorthernFullTunic copy.png": 19023,
	"./Item_Icon_TriPeltNorthernFullTunic.png": 53142,
	"./Item_Icon_TrollBlood copy.png": 46674,
	"./Item_Icon_TrollBlood.png": 66957,
	"./Item_Icon_TrollBlood_BoneDecoratedBottle.png": 92201,
	"./Item_Icon_TrollPelt copy.png": 30653,
	"./Item_Icon_TrollPelt.png": 79752,
	"./Item_Icon_TrollsBane copy.png": 72543,
	"./Item_Icon_TrollsBane.png": 15750,
	"./Item_Icon_TrollsClub copy.png": 49915,
	"./Item_Icon_TrollsClub.png": 75698,
	"./Item_Icon_Troubadour.png": 14665,
	"./Item_Icon_TroubadourOutfit.png": 74936,
	"./Item_Icon_Turnshoe copy.png": 72799,
	"./Item_Icon_Turnshoe.png": 75334,
	"./Item_Icon_ValentineCandies copy.png": 63268,
	"./Item_Icon_ValentineCandies.png": 72075,
	"./Item_Icon_VigilantCloak copy.png": 65425,
	"./Item_Icon_VigilantCloak.png": 96908,
	"./Item_Icon_VikingHelm copy.png": 65625,
	"./Item_Icon_VikingHelm.png": 70116,
	"./Item_Icon_VikingSword_0001 copy.png": 67472,
	"./Item_Icon_VikingSword_0001.png": 17751,
	"./Item_Icon_VikingSword_1001.png": 60072,
	"./Item_Icon_VikingSword_2001 copy.png": 95762,
	"./Item_Icon_VikingSword_2001.png": 96557,
	"./Item_Icon_VikingSword_3001.png": 66446,
	"./Item_Icon_VikingSword_4001 copy.png": 34804,
	"./Item_Icon_VikingSword_4001.png": 71643,
	"./Item_Icon_VikingSword_5001 copy.png": 14017,
	"./Item_Icon_VikingSword_5001.png": 49404,
	"./Item_Icon_VikingSword_6001 copy.png": 6038,
	"./Item_Icon_VikingSword_6001.png": 47953,
	"./Item_Icon_VikingSword_7001.png": 22322,
	"./Item_Icon_VisoredBarbutaHelm copy.png": 15814,
	"./Item_Icon_VisoredBarbutaHelm.png": 51617,
	"./Item_Icon_VisoredSallet copy.png": 31062,
	"./Item_Icon_VisoredSallet.png": 32113,
	"./Item_Icon_VoidBlade copy.png": 12401,
	"./Item_Icon_VoidBlade.png": 23820,
	"./Item_Icon_VolcanicAsh copy.png": 82222,
	"./Item_Icon_VolcanicAsh.png": 72025,
	"./Item_Icon_WandererAttire copy.png": 94894,
	"./Item_Icon_WandererAttire.png": 57945,
	"./Item_Icon_WarHammer copy.png": 22965,
	"./Item_Icon_WarHammer.png": 56912,
	"./Item_Icon_WarMaul_0001 copy.png": 18834,
	"./Item_Icon_WarMaul_0001.png": 92365,
	"./Item_Icon_WarMaul_1001.png": 65134,
	"./Item_Icon_WarMaul_2001 copy.png": 43984,
	"./Item_Icon_WarMaul_2001.png": 44183,
	"./Item_Icon_WarMaul_3001.png": 58760,
	"./Item_Icon_WarMaul_4001 copy.png": 60502,
	"./Item_Icon_WarMaul_4001.png": 4113,
	"./Item_Icon_WarMaul_5001 copy.png": 67579,
	"./Item_Icon_WarMaul_5001.png": 25458,
	"./Item_Icon_WarMaul_6001 copy.png": 86644,
	"./Item_Icon_WarMaul_6001.png": 955,
	"./Item_Icon_WarMaul_7001 copy.png": 49185,
	"./Item_Icon_WarMaul_7001.png": 52540,
	"./Item_Icon_WardenOutfit copy.png": 17985,
	"./Item_Icon_WardenOutfit.png": 38204,
	"./Item_Icon_Wardweed copy.png": 2796,
	"./Item_Icon_Wardweed.png": 84003,
	"./Item_Icon_WarlordsArmorShard.png": 491,
	"./Item_Icon_WarlordsBrokenSwordBlade.png": 87152,
	"./Item_Icon_WatchmanCloak copy.png": 91922,
	"./Item_Icon_WatchmanCloak.png": 69709,
	"./Item_Icon_Weapons_Common.png": 72531,
	"./Item_Icon_Weapons_Epic.png": 20407,
	"./Item_Icon_Weapons_Legend.png": 11171,
	"./Item_Icon_Weapons_Legendary.png": 8977,
	"./Item_Icon_Weapons_Poor.png": 59080,
	"./Item_Icon_Weapons_Rare.png": 13544,
	"./Item_Icon_Weapons_Uncommon.png": 86182,
	"./Item_Icon_Weapons_Unique.png": 93837,
	"./Item_Icon_WendigosAntlerFragment.png": 63014,
	"./Item_Icon_WendigosEntrails.png": 14000,
	"./Item_Icon_WendigosHoof copy.png": 37171,
	"./Item_Icon_WendigosHoof.png": 46394,
	"./Item_Icon_WendigosSharpClaws copy.png": 95543,
	"./Item_Icon_WendigosSharpClaws.png": 69742,
	"./Item_Icon_WindLocket.png": 26334,
	"./Item_Icon_WindlassCrossbow_0001 copy.png": 14798,
	"./Item_Icon_WindlassCrossbow_0001.png": 50233,
	"./Item_Icon_WindlassCrossbow_1001.png": 86330,
	"./Item_Icon_WindlassCrossbow_2001 copy.png": 31180,
	"./Item_Icon_WindlassCrossbow_2001.png": 40995,
	"./Item_Icon_WindlassCrossbow_3001.png": 55044,
	"./Item_Icon_WindlassCrossbow_4001 copy.png": 30986,
	"./Item_Icon_WindlassCrossbow_4001.png": 91381,
	"./Item_Icon_WindlassCrossbow_5001 copy.png": 94607,
	"./Item_Icon_WindlassCrossbow_5001.png": 78678,
	"./Item_Icon_WindlassCrossbow_6001 copy.png": 3400,
	"./Item_Icon_WindlassCrossbow_6001.png": 37695,
	"./Item_Icon_WindlassCrossbow_7001 copy.png": 79477,
	"./Item_Icon_WindlassCrossbow_7001.png": 30576,
	"./Item_Icon_WizardHat copy.png": 23449,
	"./Item_Icon_WizardHat.png": 32068,
	"./Item_Icon_WizardShoes copy.png": 55100,
	"./Item_Icon_WizardShoes.png": 23987,
	"./Item_Icon_WizardStaff_0001 copy.png": 23780,
	"./Item_Icon_WizardStaff_0001.png": 24427,
	"./Item_Icon_WizardStaff_1001.png": 27084,
	"./Item_Icon_WizardStaff_2001 copy.png": 83014,
	"./Item_Icon_WizardStaff_2001.png": 98081,
	"./Item_Icon_WizardStaff_3001.png": 80834,
	"./Item_Icon_WizardStaff_4001 copy.png": 38208,
	"./Item_Icon_WizardStaff_4001.png": 44071,
	"./Item_Icon_WizardStaff_5001 copy.png": 73805,
	"./Item_Icon_WizardStaff_5001.png": 33912,
	"./Item_Icon_WizardStaff_6001 copy.png": 36962,
	"./Item_Icon_WizardStaff_6001.png": 66269,
	"./Item_Icon_WizardStaff_7001 copy.png": 96167,
	"./Item_Icon_WizardStaff_7001.png": 68606,
	"./Item_Icon_WolfClaw copy.png": 18432,
	"./Item_Icon_WolfClaw.png": 9447,
	"./Item_Icon_WolfFang copy.png": 48097,
	"./Item_Icon_WolfFang.png": 26620,
	"./Item_Icon_WolfHunterLeggings copy.png": 33325,
	"./Item_Icon_WolfHunterLeggings.png": 92728,
	"./Item_Icon_WolfPelt copy.png": 83212,
	"./Item_Icon_WolfPelt.png": 26723,
	"./Item_Icon_YetisTeeth.png": 9798,
	"./Item_Icon_Zweihander_0001 copy.png": 4430,
	"./Item_Icon_Zweihander_0001.png": 28665,
	"./Item_Icon_Zweihander_1001.png": 18682,
	"./Item_Icon_Zweihander_2001 copy.png": 13388,
	"./Item_Icon_Zweihander_2001.png": 89699,
	"./Item_Icon_Zweihander_3001.png": 76004,
	"./Item_Icon_Zweihander_4001 copy.png": 89898,
	"./Item_Icon_Zweihander_4001.png": 16789,
	"./Item_Icon_Zweihander_5001 copy.png": 72143,
	"./Item_Icon_Zweihander_5001.png": 87734,
	"./Item_Icon_Zweihander_6001 copy.png": 45832,
	"./Item_Icon_Zweihander_6001.png": 65599,
	"./Item_Icon_Zweihander_7001 copy.png": 34466,
	"./Item_Icon_Zweihander_7001.png": 39632,
	"./Item_Icon_gems_Legendary.png": 66476,
	"./T_Item_Icon_MysticGloves.png": 19228,
	"./image.png": 19669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25767;